import React, { useEffect, useState } from 'react';
import CustomerDetailsHeader from './CustomerDetailsHeader';
import CustomerInfo from './CustomerInfo';
import CustomerLog from './CustomerLog';
import {
  getCustomerDetails,
  getCustomerJobList,
  updateDetails
} from 'nursd-dashboard/api/customerTable';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { Button, Card, Col, Form, Modal, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Flex from 'components/common/Flex';
import { getOrderAll } from 'nursd-dashboard/api/order';
import CustomerOrderLog from './CustomerOrderLog';
import CustomerCarePeriod from './CustomerCarePeriod';
import IconButton from 'components/common/IconButton';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
import { removeFormatting } from 'nursd-dashboard/utils/function';

const CustomersDetails = () => {
  const { authToken } = useAuth();
  const { customerId } = useParams();
  const [loading, setLoading] = useState(true);
  const [customer, setCustomer] = useState(true);
  const [customerJobList, setCustomerJobList] = useState([]);
  const [customerOrderList, setCustomerOrderList] = useState([]);
  const [addCarePeriod, setAddCarePeriod] = useState(false);
  const [formData, setFormData] = useState({
    startDate: new Date(),
    endDate: new Date()
  });

  const getCustomer = async id => {
    setLoading(true);
    try {
      const detail = await getCustomerDetails(authToken, id);
      const job = await getCustomerJobList(authToken, id);
      const order = await getOrderAll(authToken, 'Customer', id);
      setCustomer(detail);
      setCustomerJobList(job);
      setCustomerOrderList(order);
      setLoading(false);
    } catch (error) {
      setCustomer([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (customerId !== '') {
      getCustomer(customerId);
    }
  }, [authToken, customerId]);

  const updateCustomer = async () => {
    try {
      if (customer?.additionalFields?.[0]) {
        const carePeriod = customer.additionalFields[0].carePeriod || [];
        customer.additionalFields[0].carePeriod = [
          ...carePeriod,
          {
            startDate: new Date(formData?.startDate),
            endDate: new Date(formData?.endDate)
          }
        ];
      }

      const formatPhone = phone => (phone ? removeFormatting(phone) : '');

      const res = await updateDetails(authToken, customerId, {
        firstName: customer?.firstName,
        lastName: customer?.lastName,
        fullAddress: customer?.fullAddress,
        latitude: customer?.latitude?.toString(),
        longitude: customer?.longitude?.toString(),
        cityId: '',
        city: customer?.city,
        state: customer?.state,
        zipCode: customer?.zipCode,
        gender: customer?.gender,
        phoneOne: formatPhone(customer?.patientOne),
        phoneTwo: formatPhone(customer?.patientTwo),
        email: customer?.email,
        password: customer?.password,
        active: true,
        additionalFields: customer.additionalFields
      });

      toast.success('Care period added successfully.', { theme: 'colored' });

      setFormData({
        startDate: new Date(),
        endDate: new Date()
      });
      setAddCarePeriod(!addCarePeriod);

      console.log(res);

      await getCustomer(customerId);
    } catch (error) {
      console.log('Data save error:', error);
    }
  };
  console.log(customer?.additionalFields);
  return (
    <>
      {loading ? (
        <Card>
          <p className="m-3">Loading...</p>
        </Card>
      ) : (
        <>
          <CustomerDetailsHeader customer={customer} />
          <CustomerInfo customer={customer} />
          {customer?.additionalFields[0]?.carePeriod ? (
            <CustomerCarePeriod
              customerCarePeriodList={customer?.additionalFields[0]?.carePeriod}
              setAddCarePeriod={setAddCarePeriod}
            />
          ) : (
            <Card className="mb-3">
              <Card.Header>
                <Flex justifyContent={'between'}>
                  <h5 className="mb-0">Care Period</h5>
                  <IconButton
                    variant="primary"
                    iconClassName="me-2"
                    icon="plus"
                    size="sm"
                    className="mb-2 mx-2"
                    onClick={() => {
                      setAddCarePeriod(!addCarePeriod);
                    }}
                  >
                    Create
                  </IconButton>
                </Flex>
              </Card.Header>
              <Card.Body className="bg-body-tertiary border-top">
                <Row>
                  <Col lg xxl={5}>
                    <h6 className="fw-semibold ls mb-3 text-uppercase">
                      No Records
                    </h6>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}

          {customerJobList?.length !== 0 ? (
            <CustomerLog customerJobList={customerJobList} />
          ) : (
            <Card className="mb-3">
              <Card.Header>
                <Flex justifyContent={'between'}>
                  <h5 className="mb-0">Job List</h5>
                </Flex>
              </Card.Header>
              <Card.Body className="bg-body-tertiary border-top">
                <Row>
                  <Col lg xxl={5}>
                    <h6 className="fw-semibold ls mb-3 text-uppercase">
                      No Records
                    </h6>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}

          {customerOrderList?.length !== 0 ? (
            <CustomerOrderLog customerOrderList={customerOrderList} />
          ) : (
            <Card className="mb-3">
              <Card.Header>
                <Flex justifyContent={'between'}>
                  <h5 className="mb-0">Order List</h5>
                </Flex>
              </Card.Header>
              <Card.Body className="bg-body-tertiary border-top">
                <Row>
                  <Col lg xxl={5}>
                    <h6 className="fw-semibold ls mb-3 text-uppercase">
                      No Records
                    </h6>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}
        </>
      )}
      <Modal
        size="xl"
        show={addCarePeriod}
        backdrop="static"
        keyboard={false}
        aria-labelledby="example-modal-sizes-title-lg"
        // onHide={handleClose}
        contentClassName="border"
      >
        <Modal.Header>
          <h4>Create Care Period</h4>
        </Modal.Header>
        <Modal.Body className="p-x1">
          <Row className="mb-2">
            <Form.Group
              as={Col}
              md={'6'}
              className="mb-2"
              controlId="startDate"
            >
              <Form.Label className="fs-9">Start</Form.Label>
              <DatePicker
                selected={formData?.startDate}
                minDate={moment().toDate()}
                minTime={
                  moment(formData?.startDate).format('MM/DD/YYYYY') ===
                  moment().format('MM/DD/YYYYY')
                    ? moment().toDate() // Set minTime to current time if today
                    : new Date(0, 0, 0, 0, 0, 0) // If it's another day, set minTime to 00:00
                }
                maxTime={new Date(0, 0, 0, 23, 59, 59)} // Limit the maximum time to the end of the day
                onChange={v => {
                  setFormData({
                    ...formData,
                    startDate: v,
                    endDate: new Date(v)
                  });
                }}
                className="form-control"
                placeholderText="MM-DD-YYYY"
                dateFormat="MM-dd-yyyy"
              />
            </Form.Group>
            <Form.Group as={Col} md={'6'} className="mb-2" controlId="endDate">
              <Form.Label className="fs-9">End</Form.Label>
              <DatePicker
                selected={formData?.endDate}
                minDate={moment().toDate()}
                minTime={
                  moment(formData?.endDate).format('MM/DD/YYYYY') ===
                  moment().format('MM/DD/YYYYY')
                    ? moment().toDate() // Set minTime to current time if today
                    : new Date(0, 0, 0, 0, 0, 0) // If it's another day, set minTime to 00:00
                }
                maxTime={new Date(0, 0, 0, 23, 59, 59)} // Limit the maximum time to the end of the day
                onChange={v => {
                  setFormData({
                    ...formData,
                    endDate: new Date(v)
                  });
                }}
                className="form-control"
                placeholderText="MM-DD-YYYY"
                dateFormat="MM-dd-yyyy"
              />
            </Form.Group>
          </Row>
        </Modal.Body>
        <Modal.Footer className="bg-body-tertiary px-x1 border-top-0">
          <Button
            variant="primary"
            className="px-4 mx-0"
            onClick={() => {
              updateCustomer();
            }}
          >
            Create Period
          </Button>
          <Button
            variant="secondary"
            type="submit"
            className="px-4 mx-2"
            onClick={() => {
              setAddCarePeriod(!addCarePeriod);
              setFormData({
                startDate: new Date(),
                endDate: new Date()
              });
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomersDetails;
